<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ded">
<p class="ded"><a class="page" id="pvii"></a>For Dana, with love</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Hardesty-0005.vue?50f64834